<template>
  <div class="wrapper">
    <div class="main visual-2">
      <Header />
      
      <div class="selection-container container">
        <div class="text-center">
          <h2 class="welcome-text">Welcome, Super Admin</h2>
          <p class="text-muted">Please choose your workspace destination</p>
        </div>

        <div class="row justify-content-center align-items-stretch">
          <!-- User Management Card -->
          <!-- <div class="col-md-5">
            <div class="selection-card glass-panel h-100" @click="$router.push('/user-management')">
              <div class="card-icon icon-blue">
                <i class="fa-solid fa-users-gear"></i>
              </div>
              <h3>User Management</h3>
              <p>Manage system users, roles, and permissions across all hospitals.</p>
              <button class="btn btn-primary w-100 mt-auto">Go to User Management</button>
            </div>
          </div> -->

          <!-- Hospital Selection Card -->
          <div class="col-md-6">
            <div class="selection-card glass-panel h-100">
              <div class="card-icon icon-green">
                <i class="fa-solid fa-hospital"></i>
              </div>
              <h3>Hospital View</h3>
              <p>Select a specific hospital to view its dashboard and manage its specific data.</p>
              
              <div class="hospital-selector mt-auto">
                <label class="form-label small text-muted">Select Hospital</label>
                <select 
                  v-model="selectedHospitalId" 
                  class="form-select hospital-dropdown"
                  @change="handleHospitalChange"
                  :disabled="isLoadingHospitals"
                >
                  <option value="" disabled>-- Choose a Hospital --</option>
                  <option v-for="h in hospitals" :key="h.id || h._id" :value="h.id || h._id">
                    {{ h.name }}
                  </option>
                </select>
                <div v-if="isLoadingHospitals" class="text-center mt-2">
                  <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <FooterView :showButtons="true" />
    </div>
  </div>
</template>

<script>
import Header from "@/layout/Header.vue";
import FooterView from "@/layout/Footer.vue";
// import { HospitalsService } from "@/services/hospitals.service";
import { AuthService } from "@/services/auth.service";

export default {
  name: "SuperAdminSelection",
  components: { Header, FooterView },
  data() {
    return {
      hospitals: [],
      selectedHospitalId: "",
      isLoadingHospitals: false
    };
  },
  async mounted() {
    this.fetchHospitals();
  },
  methods: {
    async fetchHospitals() {
      this.isLoadingHospitals = true;
      try {
        const response = await AuthService.getSuperAdminHospitals();
        this.hospitals = response.data.items || [];
      } catch (error) {
        console.error("Error fetching hospitals:", error);
        this.$store.commit("toast/NEW", {
          type: "error",
          message: "Failed to load hospitals list"
        });
      } finally {
        this.isLoadingHospitals = false;
      }
    },
    async handleHospitalChange() {
      if (!this.selectedHospitalId) return;
      
      try {
        const response = await AuthService.updateActiveHospital(this.selectedHospitalId);
        
        if (response.success) {
          const responseData = response.data || {};
          const token = responseData.token || responseData.jwt;
          const user = responseData.user || responseData.payload;
          const hospitalId =
            responseData.activeHospital?.id ||
            user?.hospitalId ||
            this.selectedHospitalId;
          
          if (token) {
            localStorage.setItem("token", token);
          }
          
          if (user) {
            this.$store.commit("user/SET_CURRENT_USER", user);
          }

          // Also update hospitalId in localStorage for consistency
          localStorage.setItem("hospitalId", hospitalId);

          await AuthService.getProfile();

          this.$store.commit("toast/NEW", {
            type: "success",
            message: "Hospital selected successfully!"
          });

          this.$router.push("/");
        } else {
          throw new Error(response.message || "Failed to update active hospital");
        }
      } catch (error) {
        console.error("Error updating active hospital:", error);
        this.$store.commit("toast/NEW", {
          type: "error",
          message: error.message || "Failed to update active hospital"
        });
      }
    }
  }
};
</script>

<style scoped>
.selection-container {
  margin-top: 150px;
  padding-bottom: 100px;
}

.welcome-text {
    font-size: 32px;
    font-weight: 700;
    color: #0144A6;
}

.selection-card {
  padding: 40px;
  border-radius: 24px;
  text-align: center;
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(0, 0, 0, 0.05);
  background: white;
}

.selection-card:hover {
  transform: translateY(-12px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  border-color: #3c78f9;
}

.card-icon {
  width: 90px;
  height: 90px;
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
  color: white;
  margin: 0 auto 30px;
  box-shadow: 0 10px 20px rgba(0,0,0,0.1);
}

.icon-blue { background: linear-gradient(135deg, #3c78f9, #0144A6); }
.icon-green { background: linear-gradient(135deg, #28a745, #1e7e34); }

.selection-card h3 {
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 15px;
}

.selection-card p {
  color: #6c757d;
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 30px;
}

.hospital-dropdown {
  padding: 14px;
  border-radius: 12px;
  border: 1px solid #e0e0e0;
  font-size: 16px;
  background-color: #f8f9fa;
  transition: all 0.2s;
}

.hospital-dropdown:focus {
    border-color: #3c78f9;
    box-shadow: 0 0 0 4px rgba(60, 120, 249, 0.1);
    background-color: white;
}

.btn-primary {
    padding: 12px;
    border-radius: 12px;
    font-weight: 600;
    font-size: 16px;
    background: #3c78f9;
    border: none;
    transition: all 0.3s;
}

.btn-primary:hover {
    background: #0144A6;
    transform: scale(1.02);
}

.glass-panel {
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
}

@media (max-width: 768px) {
  .selection-container {
    margin-top: 100px;
    padding-bottom: 150px;
  }
  
  .selection-card {
      padding: 30px;
  }
}
</style>
